<template>
    <div class="p-ai-center p-grid p-jc-center">
        <div class=" p-col">
            <div class="p-inputgroup">
                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'השבוע הקודם'"
                        @click="navigateWeek(false)"
                        icon="pi  pi-angle-right"
                        class=

                                "button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>
                <Calendar
                        :showButtonBar="true"
@input="onSelect"
                        style="'text-align: center !important'"
                        class="calendar-hebrew calendar-picker-presence"
                        :manualInput="false"
                        monthNavigator
                        yearNavigator
                        yearRange="2023:2040"
                        :disabledDays="[6]"
                        v-model="selectedDate"
                        :dateFormat="weekFormat"
                />
                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'השבוע הבא'"
                        @click="navigateWeek(true)"
                        icon="pi  pi-angle-left"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {
    dateToFullHebrew,
    getNextWeekDate,
    getPreviousWeekDate,
    getWeekRange,
    toFullHebrewWeekRange
} from "@/utils/hebrewDateFormat";

export default {
    props: {
        storageName: {
            type: String,
            default: "default"
        },
        useStore: {
            type: Boolean,
            default: false
        },
        navigateButtons: {
            type: Boolean,
            default: false
        },  defaultValue: {
            type: String,
            default: null
        },
    },
    name: "SelectDate",
    data: () => ({
        selectedDate: null
    }),
    methods: {
        onSelect() {
            Vue.ls.set(`selectWeek_${this.storageName}`, this.selectedDate.getTime())
            const weekRange = getWeekRange(this.selectedDate.getTime())
            this.$emit('onSelect', weekRange);
        },
        navigateWeek(isAdd) {
            this.selectedDate = isAdd ? getNextWeekDate(this.selectedDate) : getPreviousWeekDate(this.selectedDate)
            this.onSelect()
        },

    },
    computed: {
        weekFormat() {
            return toFullHebrewWeekRange(this.selectedDate);
        }
    },
    mounted() {
        if (this.defaultValue !== null){
            this.selectedDate = this.defaultValue
            this.onSelect()
        } else if(this.useStore) {
            this.selectedDate = new Date(Vue.ls.get(`selectWeek_${this.storageName}`)) || new Date()
            this.onSelect()
        }
    }
}
</script>

<style scoped>

</style>